<template>
  <el-dialog id="client-crud"
             :title="((this.client) ? 'Edit' : 'Create') + ' Client'"
             @close="close"
             v-loading="loading"
             :element-loading-text="'Saving Client...'"
             :visible.sync="isVisible"
             :width="(isDialogFullscreen) ? '' : '480px'"
             :fullscreen="isDialogFullscreen">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="user-form">
      <el-form-item  label="Icon (150x150)" prop="icon">
        <el-upload
          class="icon-uploader circular"
          :class="{uploaded: imagePreviewUrl}"
          v-loading="iconLoading"
          :action="ClientsIconURL"
          :headers="uploadFormHeaders"
          drag
          :show-file-list="false"
          :on-success="handleIconSuccess"
          :before-upload="beforeIconUpload">
          <img v-if="imagePreviewUrl" :src="imagePreviewUrl" class="icon">
          <i v-else class="el-icon-plus icon-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="Name" prop="name">
        <el-input v-model="form.name" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Code" prop="code" ref="client_code">
        <el-input v-model="form.code" :disabled="!!this.client" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Email" prop="email">
        <el-input v-model="form.email" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Phone" prop="phone">
        <el-input v-model="form.phone" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Comment" prop="comment">
        <el-input v-model="form.comment" type="textarea" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Type" prop="clientType" v-if="!client || client.prospect">
        <el-radio-group v-model="form.clientType">
          <el-radio-button label="Onboarding"></el-radio-button>
          <el-radio-button label="Client"></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Archived" prop="status" v-if="this.client && !this.client.archived && isAdmin">
        <el-switch v-model="form.archived" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="isVisible = false">Cancel</el-button>
      <el-button type="primary" @click="submit">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {ClientsIconURL} from '../../util/api'
  export default {
    name: 'client-crud',
    props: {
      client: null
    },
    data () {
      return {
        isVisible: true,
        loading: false,
        windowWidth: 0,
        prospectUpgraded: false, // Did a prospect upgrade to client
        clientArchived: false, // Did the client get archived?
        ClientsIconURL: ClientsIconURL,
        uploadFormHeaders: {
          'Authorization': 'Bearer ' + this.$store.state.accessToken
        },
        iconLoading: false,
        imagePreviewUrl: false,
        form: {
          name: '',
          code: '',
          email: '',
          phone: '',
          comment: '',
          clientType: 'Onboarding',
          archived: false
        },

        rules: {
          name: [
            { required: true, message: 'Name is required', trigger: 'blur' }
          ],
          code: [
            { required: true, message: 'Code  is required', trigger: 'blur' }
          ],
          email: [
            { type: 'email', message: 'Email Address is not in valid format', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      submit () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (!this.validateIsCodeUnique()) {
              return false
            }

            this.prospectUpgraded = false

            // @Note: See watcher 'saving' for the success/error handling of this action
            var object = {
              id: (this.client) ? this.client.id : null,
              name: this.form.name,
              code: this.form.code,
              email: this.form.email,
              phone: this.form.phone,
              comment: this.form.comment,
              icon: this.form.icon,
              archived: this.form.archived,
              prospect: this.form.clientType === 'Onboarding'
            }

            // Are we upgrading from prospect to client?
            if (this.client && this.client.prospect && !object.prospect) {
              this.prospectUpgraded = true
            }

            if (this.client && !this.client.archived && object.archived) {
              this.clientArchived = true
            }

            if (this.client) {
              // A client was passed, update it
              this.$store.dispatch('updateClient', object)
            } else {
              // A client was not past, create a new one
              this.$store.dispatch('createClient', object)
            }
          } else {
            return false
          }
        })
      },
      setClientDetails () {
        if (this.client) {
          this.form.name = this.client.name
          this.form.code = this.client.code
          this.form.email = this.client.email
          this.form.phone = this.client.phone
          this.form.comment = this.client.comment
          this.form.clientType = (!this.client.prospect) ? 'Client' : 'Onboarding'
          this.form.archived = this.client.archived
          this.form.icon = this.client.icon

          if (this.client.icon) {
            this.imagePreviewUrl = this.client.icon_url
          }
        }
      },
      getWindowWidth () {
        this.windowWidth = document.documentElement.clientWidth
      },
      validateIsCodeUnique () {
        if (!this.client && this.form.code.trim() !== '') {
          for (let k in this.clients) {
            console.log(this.clients[k].code.toLowerCase(), this.form.code.toLowerCase())
            if (this.clients[k].code.toLowerCase() === this.form.code.toLowerCase()) {
              this.$refs['client_code'].error = 'Client Code already in use'
              return false
            }
          }
        }
        return true
      },
      handleIconSuccess (res, file) {
        this.form.icon = file.response.filename
        this.imagePreviewUrl = file.response.preview
        this.iconLoading = false
      },
      beforeIconUpload (file) {
        const isPNG = (file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPNG) {
          this.$message.error('Icon must be PNG format!')
        }
        if (!isLt2M) {
          this.$message.error('Icon size can not exceed 2MB!')
        }
        if (isPNG && isLt2M) {
          this.iconLoading = true
          return true
        }

        return false
      }
    },
    computed: {
      isDialogFullscreen () {
        return this.windowWidth < 520
      },
      // Vuex Mappings
      saving () {
        return this.$store.state.clients.createInProgress || this.$store.state.clients.updateInProgress
      },
      affectedClient () {
        if (this.client) {
          return this.$store.state.clients.updatedObject
        } else {
          return this.$store.state.clients.createdObject
        }
      },
      clients () {
        return this.$store.state.clients.objects
      },
      isAdmin () {
        return this.$store.getters.isAdmin
      }
    },
    mounted () {
      this.setClientDetails()
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth)
        this.getWindowWidth()
      })
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.getWindowWidth)
    },
    watch: {
      'client' () {
        this.setClientDetails()
      },
      'saving' () {
        // If the Project store is either POSTing or PUTing, show the loader if the action is in progress
        // otherwise handle the expected result of a save
        if (this.saving) {
          this.loading = true
        } else {
          this.loading = false
          if (!this.affectedClient) {
            // There was an error creating/updaing the project.
            // @TODO: Implement error handling
            console.error('Create/Update Failed. @TODO: Add error handling')
          } else {
            this.$message({
              message: (this.client) ? 'Client updated!' : 'Client created!',
              type: 'success'
            })
            if (this.prospectUpgraded) {
              setTimeout(function () {
                this.$message({
                  message: this.client.name + ' promoted to Client!'
                })
              }.bind(this), 3000)
            }

            if (this.clientArchived) {
              setTimeout(function () {
                this.$message({
                  message: this.client.name + ' Archived!'
                })
              }.bind(this), 3000)
            }
            this.isVisible = false
            this.$emit('close', this.affectedClient)
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
</style>
